export default Object.assign(isUrl, { ofSite: isUrlOfSite, ofMail: isUrlOfMail, ofPhone: isUrlOfPhone, isUrlOfScript });

// #region Helpers

const siteRegExp = /^(http|ftp)s?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/i;
const mailRegExp = /^mailto:[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const telRegExp = /^tel:[+]?\d+([\s,-]?\d+)*([;&]ext=\d+)?$/i;

function isUrl(string: string, options?: { allowScript?: boolean }): boolean {
    if (isUrlOfSite(string)) return true;
    if (isUrlOfMail(string)) return true;
    if (isUrlOfPhone(string)) return true;
    if (options?.allowScript && isUrlOfScript(string)) return true;
    return false;
}

function isUrlOfSite(string: string): boolean {
    return siteRegExp.test(string);
}

function isUrlOfMail(string: string): boolean {
    return mailRegExp.test(string);
}

function isUrlOfPhone(string: string): boolean {
    return telRegExp.test(string);
}

function isUrlOfScript(string: string): boolean {
    return string.toLowerCase().startsWith('javascript:');
}

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, test, expect } = import.meta.vitest;
    describe('isUrl', async () => {
        test('validates site links', () => {
            expect(isUrl('http://atlas.co')).toBe(true);
            expect(isUrl('http://atlas.so/path-to/file.html?that=is&turned#here')).toBe(true);
            expect(isUrl('https://atlas.so/')).toBe(true);
            expect(isUrl('https://app.atlas.so/')).toBe(true);
            expect(isUrl('https://get-1atlas.io/')).toBe(true);
            expect(isUrl('https://localhost')).toBe(true);
            expect(isUrl('https://localhost?com')).toBe(true);
            expect(isUrl('https://localhost#com')).toBe(true);
            expect(isUrl('https://app.com?no way')).toBe(false);
        });

        test('validates mail links', () => {
            expect(isUrl('mailto:jon@atlas.so')).toBe(true);
            expect(isUrl('mailto:stas+1@atlas.so')).toBe(true);
            expect(isUrl('mailto:contact-atlas.here@atlas.so')).toBe(true);
            expect(isUrl('mailto:@atlas.so')).toBe(false);
            expect(isUrl('mailto:contact@atlas')).toBe(false);
            expect(isUrl('mailto:contact@ atlas.so')).toBe(false);
        });

        test('validates phone numbers', () => {
            expect(isUrl('tel:+1234567890')).toBe(true);
            expect(isUrl('tel:555-123-4567')).toBe(true);
            expect(isUrl('tel:+441234567890')).toBe(true);
            expect(isUrl('tel:+1-555-123-4567')).toBe(true);
            expect(isUrl('tel:+1234567890;ext=123')).toBe(true);
            expect(isUrl('tel:+123456789O')).toBe(false);
            expect(isUrl('tel: +1234567890')).toBe(false);
        });
    });
}
// #endregion
